import { TextLabel } from '@core/components/Inputs';
import { formatTELEFONE } from '@format';
import { Grid } from '@material-ui/core';
import React from 'react';

function ContatoPanel({ transportadora }) {
  const { pessoa = {} } = transportadora;
  const { contatos = [{}] } = pessoa;

  return (
    <Grid container spacing={0}>
      {contatos.map((contato, indexContato) => {
        return (
          <Grid key={`contato-${indexContato}`} container item xs={12} spacing={3}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <TextLabel
                id={`pessoa.contatos[${indexContato}].nomeReferencia`}
                value={contato.nomeReferencia}
                label="Nome do contato"
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
              <TextLabel
                id={`pessoa.contatos[${indexContato}].numero`}
                value={contato.numero}
                label="Telefone principal"
                format={formatTELEFONE}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
              <TextLabel id={`pessoa.contatos[${indexContato}].email`} label="E-mail principal" value={contato.email} />
            </Grid>

            <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
              <TextLabel
                id={`pessoa.contatos${indexContato}.telefonesAdicionais.numero`}
                value={contato.telefonesAdicionais}
                map="numero"
                label="Telefones adicionais"
                format={formatTELEFONE}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
              <TextLabel
                id={`pessoa.contatos${indexContato}.emailsAdicionais.email`}
                value={contato.emailsAdicionais}
                map="email"
                label="E-mails adicionais"
              />
            </Grid>
          </Grid>
        );
      })}
    </Grid>
  );
}

export default ContatoPanel;
